import { useState , useEffect } from "react";
import CustomerService from "../../services/CustomerService";
import { Link,useNavigate } from "react-router-dom";
import { notification } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Lodder from "../../components/Lodder";
const ForgetPassword = () => {
  const navigate=useNavigate()
  useEffect(()=>{
    document.title="Foundry Law - Forgot Password"
  },[])
  const [submit, setSubmit] = useState(true);
  const [email, setEmail] = useState("");
  const [emailValidation, setEmailValidation] = useState({
    isValid: false,
    message: "",
  });
  const IsValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const ValidateEmail = (value) => {
    if (!value.trim()) {
      setEmailValidation({ isValid: false, message: "Email is required" });
    } else if (value.length > 100) {
      setEmailValidation({
        isValid: false,
        message: "Email not more than 50 character",
      });
    } else if (!IsValidEmail(value)) {
      setEmailValidation({
        isValid: false,
        message: "Please enter a valid email",
      });
    } else {
      setEmailValidation({
        isValid: true,
        message: "",
      });
    }
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    ValidateEmail(event.target.value);
  };
  
  const handleFormSubmit = () => {
    setSubmit(false);
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
    ValidateEmail(email);
    if (emailValidation.isValid) {
       
      CustomerService.ForgetPassword(email)
        .then((response) => {
          if (response.status) {
            /* toast.success("Please check your email", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }); */
            notification.success({
              message: 'Email sent successfully',
              description: 'Please check your mailbox.',
            });
            navigate("/")
            setSubmit(true);
          }
        })
        .catch((error) => {
          /* toast.error(error.response.data.Message) */
          notification.error({
            message: error.response.data.Message,
            /* message: error.response.data.Message, */
          });
          setSubmit(true);
        });
    } else {
      setSubmit(true);
    }
  };
  return (
    <>
    <ToastContainer />
      <div className="vh-100 d-flex justify-content-center align-items-center flex-column px-3 login-bg login-form">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <figure className="text-center mx-auto mb-0">
                <img
                  src="/logo-dark.png"
                  className="img-fluid"
                  alt="foundary logo"
                  style={{ width: 138 }}
                />
              </figure>
            </div>
          </div>
        </div>
        <div className="mx-auto card mt-2 card-width">
          <div className="card-body">
            <div className="row">
              <div className="col-12 text-center">
                <p className="card-title mb-3 w-100">
                  Forgot Password
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <form>
                  <input type="hidden" />
                  <div className="mb-3">
                    <label className="form-label" htmlFor="email">
                      Email<span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      className="form-control rounded-1"
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                    />
                    {!emailValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {emailValidation.message}
                      </span>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="card-footer bg-white border-0  text-center pt-0">
            {submit ? (
              <button
                type="submit"
                className="btn btn-primary w-100 submit-button mb-3"
                onClick={handleFormSubmit}
              >
                FORGOT PASSWORD
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-primary w-100 submit-button mb-3"
                onClick={handleFormSubmit}
                disabled
              >
                FORGOT PASSWORD
              </button>
            )}
            <Link to="/" className="forgot-link">Back to Login</Link>
          </div>
        </div>
      </div>
      <Lodder show={!submit}/>
      
    </>
  );
};
export default ForgetPassword;
